export const searchHitOneWhenHoverEffectVisibleVar =
  '--search-hit-one-hover-effect-visible';
export const searchHitTopBorderRadiusVar = '--search-hit-top-border-radius';
